'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosRainy = function IoIosRainy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.7 14c3 0 5.3 2.6 5.3 5.5 0 2.3-1.5 4.4-3.5 5.2l-4.3 6.2c-0.2 0.2-0.4 0.4-0.6 0.4-0.4 0-0.7-0.3-0.7-0.7 0-0.1 0.1-0.3 0.2-0.4l3.6-5.2h-2.7l-2.5 3.4c-0.1 0.2-0.3 0.4-0.5 0.4-0.4 0-0.7-0.3-0.7-0.7 0-0.1 0.1-0.2 0.1-0.4l2-2.7h-2.9l-4.1 5.9c-0.2 0.2-0.4 0.4-0.6 0.4-0.4 0-0.7-0.3-0.7-0.7 0-0.1 0.2-0.3 0.2-0.4l3.6-5.2h-2.8l-2.5 3.4c-0.1 0.2-0.3 0.4-0.5 0.4-0.4 0-0.6-0.3-0.6-0.7 0-0.1 0-0.3 0.1-0.4l2-2.7c-2.3-0.2-4.1-2.1-4.1-4.4 0-2.2 1.7-4.5 3.9-4.7 0-0.2-0.1-0.3-0.1-0.6 0-3.6 2.5-6.5 6.4-6.5 3.6 0 5.7 2.4 6.4 5.3 0.2 0 0.4-0.1 0.6-0.1z' })
        )
    );
};

exports.default = IoIosRainy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-rainy.js
// module id = 2261
// module chunks = 0